import React, { useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Box, Modal } from "@material-ui/core";
import styles from "./EvrCarryForwardModal.module.css";
import CustomDatePicker from "../CustomDatePicker/CustomDatePicker";
import { DATE_FORMAT } from "../../constants";
import moment from "moment";

const EvrCarryForwardModal = ({
  open,
  handleClose,
  rowsData,
  evrNumberCarryForwardCount,
  handleSubmit,
  cancelButtonText = "Cancel",
  submitButtonText = "Confirm",
}) => {
  const [validFromDate, setValidFromDate] = useState(null);
  const [validToDate, setValidToDate] = useState(null);
  const [highlightMandatoryFields, setHighlightMandatoryFields] = useState(
    false
  );
  const currentMonthFirstDate = moment().startOf("month");
  const currentMonthLastDate = moment().endOf("month");

  const runPreSubmissionChecks = () => {
    if (!validFromDate || !validToDate ) {
      setHighlightMandatoryFields(true);
      return false;
    }
    return true;
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <div className={styles.formContainer}>
          <div className={styles.formTitle}>
            <div>
              <span>{evrNumberCarryForwardCount}</span>
              <span>Evr Number are selected for Carry forward</span>
            </div>
          </div>
          <div className={styles.subHeading}>
            Are you sure you want to carry forward the Evr Number.
            <br /> Once done you will not be able to revert back.
          </div>
          <div className={styles.dateSectionHeading}>select Carry forward month dates</div>
          <Box className={styles.box_BasicInfo}>
            <div className={styles.gridcontainer_VCDetails}>
              <div className={styles.plantDetailsLeftLabel_BasicInfo}>
                <label className={styles.label}>Valid From</label>
              </div>
              <div className={styles.lineModalCustomDatePicker}>
                <CustomDatePicker
                  isMandatory
                  markIfUnselected={highlightMandatoryFields}
                  autoOk
                  inputVariant="outlined"
                  value={validFromDate}
                  onChange={(date) =>
                    setValidFromDate(date.format(DATE_FORMAT.ISO))
                  }
                  inputProps={{
                    className: clsx(styles.select, styles.dateInput),
                  }}
                  emptyLabel="dd/mm/yyyy"
                  minDate={currentMonthFirstDate}
                  format="DD/MM/yyyy"
                  data-testid="date-picker-div"
                />
              </div>
              <div className={styles.plantDetailsLeftLabel_BasicInfo}>
                <label className={styles.label}>Valid To</label>
              </div>
              <div className={styles.lineModalCustomDatePicker}>
                <CustomDatePicker
                  isMandatory
                  markIfUnselected={highlightMandatoryFields}
                  autoOk
                  inputVariant="outlined"
                  value={validToDate}
                  onChange={(date) =>
                    setValidToDate(date.format(DATE_FORMAT.ISO))
                  }
                  inputProps={{
                    className: clsx(styles.select, styles.dateInput),
                  }}
                  emptyLabel="dd/mm/yyyy"
                  minDate={currentMonthLastDate}
                  format="DD/MM/yyyy"
                  data-testid="date-picker-div"
                />
              </div>
            </div>
          </Box>

          <div className={styles.bottomRow}>
            <button className={styles.cancelBt} onClick={handleClose}>
              {cancelButtonText}
            </button>
            <span>
              <button
                onClick={() => {
                  if (runPreSubmissionChecks()) {
                    handleSubmit({
                      rowsData,
                      validFromDate,
                      validToDate,
                    });
                    handleClose();
                  }
                }}
                className={styles.submitBt}
              >
                {submitButtonText}
              </button>
            </span>
          </div>
        </div>
      </Modal>
    </>
  );
};

EvrCarryForwardModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  rowsData: PropTypes.arrayOf(
    PropTypes.shape({
      vc: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      market: PropTypes.string.isRequired,
      category: PropTypes.string.isRequired,
      count: PropTypes.string.isRequired,
      fbv: PropTypes.string.isRequired,
    })
  ),
  evrNumberCarryForwardCount: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  cancelButtonText: PropTypes.string,
  submitButtonText: PropTypes.string,
};

export default EvrCarryForwardModal;
